import { AppIcons } from "../constants/app-icons";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
export default class WorkOrdersService extends ApiService {
  template = "defaultTemplate";
  namespace = "work-order";
  action = "action";
  favicon = "Order";
  DOMAIN = DOMAIN.WORK_ORDER;
  search = true;
  Width = 1200;
  name = "Work Order";
  icon = "Order";
  plural = this.terminology.workOrder.plural;
  singular = this.terminology.workOrder.singular;
  vowel = this.terminology.workOrder.vowel;
  gemItems = [
    {
      key: "listing",
      label: "All Work Orders",
      icon: AppIcons.BULLETS,
    },

    {
      key: "create",
      label: "Add a Work Order",
      icon: AppIcons.PLUS,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: this.t("editAnEntity", { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: this.t("announceThisEntity", { entity: this.singular }),
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: this.t("emailThisEntity", { entity: this.singular }),
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: this.t("bookmarkThisEntity", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("inactiveThisEntity", { entity: this.singular }),
      icon: AppIcons.LOCK2,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.BARCODE,
      field: "number",
      sortable: true,
    },
    {
      header: this.t("displayName"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "display_name",
    },
    {
      header: this.t("customer"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
      sortable: true,
    },
    {
      header: this.t("contact"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "contact",
    },
    {
      header: this.t("phone") + " #",
      icon: AppIcons.MOBILE_PHONE,
      field: "display_name",
    },
    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      template: (data) => {
        return this.parseStatus(data["status"]);
      },
    },
  ];
  columns1 = [
    {
      header: "testing",
      icon: AppIcons.BARCODE,
      field: "number",
    },
    {
      header: this.t("displayName"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "display_name",
    },
    {
      header: this.t("customer"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
    },
    {
      header: this.t("contact"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "contact",
    },
    {
      header: this.t("phone") + " #",
      icon: AppIcons.MOBILE_PHONE,
      field: "display_name",
    },
    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      template: (data) => {
        return this.parseStatus(data["status"]);
      },
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      icon: AppIcons.DISABLE,
    },
  ];

  filterItems = [
    {
      name: "Folders",
      serviceId: "-2",
      value: "-2",
      realm: "0",
      selected: true,
      add: "create",
      edit: "listing",
    },
    {
      name: "Status",
      serviceId: "-2",
      value: "-3",
      realm: "0",
      selected: false,
      add: "create",
      edit: "listing",
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a Work Order",
      icon: AppIcons.LIST,
    },
  ];
  sidebarControls = [
    { type: 'checkbox', name: 'is_in_print_que', label: 'Add To Print Que' },
    { type: 'checkbox', name: 'is_in_email_que', label: 'Add to Email Que' },
    { type: 'button', key: 'savePrint', label: 'Save & Print', icon: 'Printer' },
  ];
  constructor() {
    super("work-orders");
  }
}
